import { render, staticRenderFns } from "./helpProject.vue?vue&type=template&id=09c7f04b&scoped=true&"
import script from "./helpProject.vue?vue&type=script&lang=js&"
export * from "./helpProject.vue?vue&type=script&lang=js&"
import style0 from "./helpProject.vue?vue&type=style&index=0&id=09c7f04b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c7f04b",
  null
  
)

export default component.exports